module.exports = __webpack_public_path__ + "images/account-activated.b5f5f5003046778cc62c3d9ccc4ed354.svg";